import { get, put } from '../Services/http';
import { catchError } from './Error.action';
import { CART_LOAD_ERROR, CART_RECEIVE, CART_SHOW_INFO } from '../constants';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  dataLayerAddToCart,
  dataLayerRemoveFromCart,
} from '../Services/Gtm.service';
import { updateQuantity } from '../Services/Cart.service';
import { translate } from '../Services/translation';
const toastError = (message) => toast.error(message);

export const load = () => (dispatch, getState) => {
  return get('/api/cart')
    .then((response) => response.json())
    .then((cart) => {
      dispatch(receive(cart));
    })
    .catch((ex) => dispatch(catchError(ex, (error) => loadError(error))));
};

export const loadError = (error) => ({
  type: CART_LOAD_ERROR,
  payload: {
    error,
  },
});

export const receive = (cart) => ({
  type: CART_RECEIVE,
  payload: cart,
});

export const toggle = () => (dispatch, getState) => {
  dispatch(show(!getState().cart.showInfo));
};

const show = (visible) => ({
  type: CART_SHOW_INFO,
  payload: {
    showInfo: visible,
  },
});

export const update = (articleNumber, quantity, abortController = null) => (
  dispatch,
  getState
) => {
  const { payload } = getState().checkout;
  const selectedDeliveryMethod = payload.selectedDeliveryMethod;
  const productToChange = window.__litium.preloadState.cart.orderRows.find(
    (r) => r.articleNumber == articleNumber
  );

  if (productToChange && quantity == 0) {
    dataLayerRemoveFromCart([productToChange.gtmItem]);
  }

  return put(
    `/api/cart/update`,
    { articleNumber, quantity, selectedDeliveryMethod },
    abortController
  )
    .then((response) => response.json())
    .then((cart) => {
      dispatch(receive(cart));
      dataLayerAddToCart(cart.gtmViewModel.ecommerce);
    })
    .catch((ex, error) => {
      var errorList = ex.response.json().then((errors) => {
        if (errors && errors.general[0]) {
          toastError(translate(errors.general[0]));
        }
      });
      dispatch(catchError(ex, (error) => loadError(error)));
    });
};
